export default __webpack_public_path__ + "static/media/solutions_topography.46cb3b00.png";